'use client';

import { faCalendarDays } from '@fortawesome/pro-light-svg-icons';
import Link from 'next/link';

import { Button } from '@/components/ui/button/button.component';
import { useAgendamentoNavigation } from '@/hooks/navigation/use-agendamento-navigation.hook';
import { AnalyticsEnumKeyType } from '@/types/enums/analytics/analytics.enum';

interface EntityScheduleRedirectButtonProps {
  path: string;
  label: string;
  dataTestId: string;
  analyticsEvent: AnalyticsEnumKeyType;
  className?: string;
}

export function EntityScheduleRedirectButton({
  path,
  label,
  dataTestId,
  analyticsEvent,
  className,
}: EntityScheduleRedirectButtonProps) {
  const { buildLink } = useAgendamentoNavigation();

  return (
    <Button
      startIcon={faCalendarDays}
      startIconSize="1x"
      startIconClassName="w-4 h-4 text-base"
      className={className}
      data-testid={dataTestId}
      data-analytics-event={analyticsEvent}
      asChild
    >
      <Link prefetch={false} href={buildLink({ path })}>
        {label}
      </Link>
    </Button>
  );
}
